// src/components/layout/Sidebar.js
import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";
import { useAuth } from "../../contexts/AuthContext";
import "./Sidebar.css";

const NAV_ITEMS = [
  { to: "/lessons", label: "レッスン", icon: "ti-calendar-event" },
  { to: "/studios", label: "スタジオ", icon: "ti-building" },
  { to: "/instructors", label: "インストラクター", icon: "ti-users" },
  { to: "/attendance", label: "受講記録出力", icon: "ti-file-download" },
];

function Sidebar({ open, onNavigate }) {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/login");
    } catch (error) {
      console.error("Logout error: ", error);
    }
  };

  const initial = (currentUser?.email || "?").charAt(0).toUpperCase();

  return (
    <aside className={`sidebar ${open ? "sidebar--open" : ""}`}>
      <div className="sidebar__brand">
        <span className="sidebar__logo">R</span>
        <span className="sidebar__brand-text">RUDO MANAGER</span>
      </div>

      <nav className="sidebar__nav">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            onClick={onNavigate}
            className={({ isActive }) =>
              `sidebar__link ${isActive ? "sidebar__link--active" : ""}`
            }
          >
            <i className={`ti ${item.icon}`} aria-hidden="true" />
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="sidebar__footer">
        <div className="sidebar__user">
          <span className="sidebar__avatar">{initial}</span>
          <span className="sidebar__email" title={currentUser?.email}>
            {currentUser?.email}
          </span>
        </div>
        <button
          type="button"
          className="icon-btn"
          aria-label="ログアウト"
          title="ログアウト"
          onClick={handleLogout}
        >
          <i className="ti ti-logout" aria-hidden="true" />
        </button>
      </div>
    </aside>
  );
}

export default Sidebar;
